export const topCenter = {
    originX: 'center',
    originY: 'top',
    overlayX: 'center',
    overlayY: 'bottom',
};
export const topLeft = {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
};
export const topRight = {
    originX: 'end',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'bottom',
};
export const bottomCenter = {
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
};
export const bottomLeft = {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
};
export const bottomRight = {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
};
export const leftCenter = {
    originX: 'start',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'center',
};
export const leftBottom = {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'bottom',
};
export const leftTop = {
    originX: 'start',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'top',
};
export const rightCenter = {
    originX: 'end',
    originY: 'center',
    overlayX: 'start',
    overlayY: 'center',
};
export const rightBottom = {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'bottom',
};
export const rightTop = {
    originX: 'end',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'top',
};
